import getLoad from '~/api/getLoad';
import resources from '~/modules/resources/types';
import LOADS from './types';
import {promiseAction} from '~/misc/dispatch';
import create from '~/misc/create';
import {loadRouteRelatedData} from '~/modules/loads/actions';
import loadFromState from '~/misc/loadFromState';

import * as staticMaps from '~/misc/staticmaps';

const preparePoints = (dispatch, load) => {
  const data = {
    points: {
      origin: load.from_location,
      destination: load.to_location,
    },
    pointsOnly: {
      compact: staticMaps.url(load.from_location, load.to_location, 640, 130),
    },
  };

  dispatch(create(LOADS.LOADS_POINTED, {
    id: load.id,
    data,
  }));
};

export default {
  [resources.RESOURCE]: [
    (action, {dispatch}) => {
      if (action.meta.name !== 'load') {
        return;
      }

      if (action.pending || action.error) {
        return;
      }

      preparePoints(dispatch, action.payload);

      dispatch(loadRouteRelatedData(action.payload));
    },
  ],
  [LOADS.SEARCH_LOAD_ACTIVE]: [
    (action, {dispatch, getState}) => {
      const fullState = getState();
      const loadIdentity = action.payload.identity;

      const load = loadFromState(fullState, loadIdentity);

      preparePoints(dispatch, load);
    },
    (action, {dispatch, getState}) => {
      const loadIdentity = action.payload.identity;
      const load = loadFromState(getState(), loadIdentity);

      dispatch(loadRouteRelatedData(load));
    },
  ],
  [resources.RESOURCE_REQUESTED]: [
    (action, {dispatch, getState}) => {
      if (action.payload.name !== 'load') {
        return;
      }
      promiseAction(
        dispatch,
        getState,
        resources.RESOURCE,
        getLoad(getState, action.payload.props.id.split('/')[0]),
        action.payload
      );
    },
  ],
};



// WEBPACK FOOTER //
// ./src/modules/loads/reactions.js